import { Dimensions } from "react-native"

const width = Dimensions.get('screen').width;

const scale = 375 / width;

export const responsiveText = (size) => {
    return size * scale;
}